import React from 'react';

/**
 * RateTable - Displays tiered rate structures in a clean table format
 * @param {Array} data - Array of rate structure objects
 * @param {string} title - Table title
 * @param {Array} columns - Column definitions [{ key, label, format }]
 */
const RateTable = ({ data, title, columns }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="p-4 bg-gray-50 rounded-lg text-center text-gray-500">
        {title} data not available
      </div>
    );
  }

  const formatValue = (value, format) => {
    if (value === null || value === undefined) return 'N/A';
    
    if (format === 'currency') {
      return `$${parseFloat(value).toFixed(5)}`;
    } else if (format === 'number') {
      return parseFloat(value).toFixed(2);
    } else if (format === 'integer') {
      return parseInt(value);
    }
    
    return value;
  };

  return (
    <div className="w-full">
      {title && <h4 className="text-lg font-semibold text-gray-700 mb-4">{title}</h4>}
      
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
          <thead className="bg-gray-50 border-b border-gray-300">
            <tr>
              {columns.map((column, idx) => (
                <th
                  key={`header-${idx}`}
                  className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider"
                >
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {data.map((row, rowIdx) => (
              <tr key={`row-${rowIdx}`} className="hover:bg-gray-50 transition-colors">
                {columns.map((column, colIdx) => (
                  <td
                    key={`cell-${rowIdx}-${colIdx}`}
                    className="px-6 py-4 text-sm text-gray-700"
                  >
                    {formatValue(row[column.key], column.format)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RateTable;
